import { getSelectedCustomer } from 'ClientPortal/src/context/SelectedCustomerContext'
import { getValuationApiClient } from 'ClientPortal/src/api/valuationApiClient'
import { useQuery } from '@tanstack/react-query'

const FEATURE_FLAGS_KEY = 'FEATURE_FLAGS'

export function useFetchFeatureFlags({ customerId }: { customerId?: string }) {
    const einwertApiClient = getValuationApiClient()
    const getFeatureFlagsQuery = () => einwertApiClient.features.getClientPortalFeatureFlags({ customerUuid: getSelectedCustomer()?.uuid })

    const twoMinutesInMs = 2 * 1000 * 60

    const { data, isPending } = useQuery({
        queryKey: [FEATURE_FLAGS_KEY, customerId],
        queryFn: getFeatureFlagsQuery,
        refetchInterval: twoMinutesInMs,
    })

    return { featureFlags: data?.values, isFeatureFlagsPending: isPending }
}
